<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('partner.form.contacts.title') }}</span>
          
          <div class="float-right"  v-if="compMode != CRUDMODE.READ">
            <a href="#partnerContact" name="partnerContact" @click="addPartnerContact"><span class="fa fa-plus fa-lg"></span></a>
          </div>
        </div>
        <div class="card-body">
          <div class="row">

            <table id="dataTablePartnerContactCompany" width="100%" cellspacing="0" 
                class="table table-bordered table-striped dataTable" >
             <thead>
                <tr>
                  <th >{{ $t('partner.form.contacts.name') }}</th>
                  <th >{{ $t('partner.form.contacts.familyName') }}</th>
                  <th >{{ $t('partner.form.contacts.email') }}</th>
                  <th >{{ $t('partner.form.contacts.phone') }}</th>
                  <th >{{ $t('partner.form.contacts.nativeLanguage') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th >{{ $t('partner.form.contacts.name') }}</th>
                  <th >{{ $t('partner.form.contacts.familyName') }}</th>
                  <th >{{ $t('partner.form.contacts.email') }}</th>
                  <th >{{ $t('partner.form.contacts.phone') }}</th>
                  <th >{{ $t('partner.form.contacts.nativeLanguage') }}</th>
                  <th v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </tfoot>
              <tbody>
                <tr class="odd" v-if="partnerContact.length == 0">
                    <td valign="top" colspan="6" class="dataTables_empty">Aucune donnée disponible dans le tableau</td>
                </tr>

                <tr v-for="(item, index) in partnerContact" v-bind:data-id="item.id" :key="item.id">
                  <td>
                    <input v-model.trim="item.name" name="name" type="text" class="form-control" 
                        id="nameInput" v-bind:placeholder="$t('partner.form.contacts.name')" />
                    <span class="text-danger" v-if="errors.has('name')">{{ errors.first('name') }}</span>
                  </td>
                  <td >
                    <input v-model.trim="item.familyName"  name="familyName" type="text" 
                      class="form-control" id="familyNameInput" v-bind:placeholder="$t('partner.form.contacts.familyName')" />
                    <span class="text-danger" v-if="errors.has('familyName')">{{ errors.first('familyName') }}</span>
                  </td>
                  <td>
                    <input v-model.trim="item.email"  v-validate="'email'" name="email" type="text" class="form-control" 
                      id="emailInput" v-bind:placeholder="$t('partner.form.contacts.email')">
                  </td>
                  <td>
                    <input v-model.trim="item.phone" v-mask="'(###) ###-####'"  
                      v-validate="{ rules: { regex: phoneRegex() } }" name="phone" type="text" 
                      class="form-control" id="phoneInput" placeholder="(999) 999-9999">
                    <span class="text-danger" v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
                  </td>
                  <td>
                    <multiselect v-model="item.nativeLanguage"
                        :options="languageOptions" :multiple="false" :taggable="true" @tag="f => addLanguageTag(item, f)"
                        v-bind:tag-placeholder="$t('multiselect.tag-placeholder')" 
                        v-bind:placeholder="$t('partner.form.contacts.nativeLanguage')" 
                        v-bind:deselect-label="$t('multiselect.deselect-label')"
                        v-bind:select-label="$t('multiselect.select-label')">
                    </multiselect>
                  </td>
                  <td align=center v-if="compMode != CRUDMODE.READ">
                    <a class="text-danger" v-bind:title="$t('form.delete_button')" href="#partnerContact" v-on:click="removePartnerContact(index)">
                        <span class="fa fa-lg fa-trash"></span>
                    </a>
                  </td> 
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {PartnerDto, PartnerContactDto, AddressDto, PartnerServiceClient} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'CreatePartnerContact',
    props: {
      partnerContact: {},
    },
    data() {
      return {
        isLoading: false,
        languageOptions: ['Français', 'Anglais', 'Espagnol'],
      }
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      fetchData: function() {},
      addPartnerContact: function() {
        let dto = new PartnerContactDto()
        dto.init({language: 'Français'})
        dto.address = new AddressDto()
        dto.address.init({})
        this.partnerContact.push(dto)
      },
      removePartnerContact: function(index) {
        this.partnerContact.splice(index, 1)
      },
      addLanguageTag: function(item, tag) {
        this.languageOptions.push(tag)
        item.NativeLanguage = tag
      },
    },
    components: {
      Multiselect,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>




// WEBPACK FOOTER //
// src/components/partners/CreatePartnerContact.vue